import {NextPage} from 'next';
import {ContainerComponent} from '../../../core/components/container.component';
import {useTranslation} from 'react-i18next';

const Careers: NextPage = () => {
  const { t } = useTranslation();
  return (
    <ContainerComponent>
      <div className={'text-2xl text-bold mt-4 px-4'}>{t('profile.careers')}</div>
    </ContainerComponent>
  );
};

export default Careers;
